import React, { Component } from "react";
import List from "./EquipmentList";
import AddEdit from "./EquipmentAddEdit";
import Dispose from "./EquipmentDispose";
import NewWindow from "react-new-window";
import ReportHome from "../Report/ReportHome";

export default class Equipment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: "List",
      data: null
    };
    this.handleClick = this.handleClick.bind(this);
  }
  render() {
    if (this.state.mode === "List") {
      return <List onClick={this.handleClick} />;
    } else if (this.state.mode === "Print") {
      return (
        <>
          <NewWindow copyStyles={true}>
            <ReportHome reportType="EqDispose" data={this.state.data} />
          </NewWindow>
          <List onClick={this.handleClick} />
        </>
      );
    } else if (this.state.mode === "Dispose") {
      return (
        <Dispose
          pData={this.state.data}
          onClick={this.handleClick}
          source="list"
        />
      );
    } else {
      return (
        <AddEdit
          pData={this.state.data}
          onClick={this.handleClick}
          source="list"
        />
      );
    }
  }

  handleClick(mode, data) {
    this.setState({ data, mode });
  }
}
